import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'

// Reducers
import accountsReducer from './modules/accounts'
import counterReducer from './modules/counter'
import schedulesReducer from './modules/schedules/reducer'
import { authReducer } from './modules/auth'
import { reducer as linksReducer } from './modules/links'
import { reducer as queuesReducer } from './modules/queues'
import { reducer as sitesReducer } from './modules/sites'
import subscriptionReducer from './modules/subscriptions';


export default combineReducers({
  accounts: accountsReducer,
  subscriptions: subscriptionReducer,
  auth: authReducer,
  counter: counterReducer,
  links: linksReducer,
  queues: queuesReducer,
  routing: routerReducer,
  schedules: schedulesReducer,
  sites: sitesReducer,
})



// WEBPACK FOOTER //
// ./src/reducer.js